module.exports = __webpack_public_path__ + "media/dui.345561a8.mp3";